// General
import "./source-of-funds-dialog.scss";
import { useEffect } from "react";
import { forwardRef } from "react";
// Services
import { useLazyGetGeneralOptionsQuery } from "../../../../services/data.service";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateEkycSourceOfFunds,
  updateEkycSourceOfFundsDetails,
} from "../../../../redux/store/verificationStore";
import { updateSourceOfFundsDialog } from "../../../../redux/store/dialogStore";
// Material UI
import { Dialog, Slide, TextField, useMediaQuery } from "@mui/material";
// i18next
import { useTranslation } from "react-i18next";

const SourceOfFundsDialog = () => {
  // API variables
  const [
    getGeneralOptions,
    {
      data: getGeneralOptionsData,
      error: getGeneralOptionsErrorData,
      isFetching: getGeneralOptionsFetching,
      isLoading: getGeneralOptionsLoading,
      isSuccess: getGeneralOptionsSuccess,
      isError: getGeneralOptionsIsError,
    },
  ] = useLazyGetGeneralOptionsQuery();

  // Redux variables
  const sourceOfFundsDialog = useSelector(
    (state) => state.dialog.sourceOfFundsDialog
  );
  const ekycSourceOfFunds = useSelector(
    (state) => state.verification.ekycSourceOfFunds
  );
  const ekycSourceOfFundsDetails = useSelector(
    (state) => state.verification.ekycSourceOfFundsDetails
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // Lifecycle | Mounted
  useEffect(() => {
    if (sourceOfFundsDialog) {
      getGeneralOptions(null, true);
    }
  }, [sourceOfFundsDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateSourceOfFundsDialog(false));
  };

  // Event Handlers | Button
  const onSelectSource = (value) => {
    dispatch(updateEkycSourceOfFunds(value));
  };

  // Event Handlers | TextField
  const onChangeOtherDetails = (e) => {
    dispatch(updateEkycSourceOfFundsDetails(e.target.value));
  };

  // Utility Functions
  const isFormValid = () => {
    if (!ekycSourceOfFunds) return false;
    if (ekycSourceOfFunds?.value === "other" && !ekycSourceOfFundsDetails)
      return false;

    return true;
  };

  return (
    <Dialog
      className={
        isMobile
          ? "custom-top-radius20-dialog custom-dialog-margin-top"
          : "custom-radius35-dialog"
      }
      fullScreen={isMobile ? true : false}
      open={sourceOfFundsDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div
        id="source-of-funds-dialog"
        className={isMobile ? "" : "max-width-container"}
      >
        <div className="dialog-header">
          <div className="dialog-title">
            {t("verification.ekyc.details_verification.source_of_funds_label")}
          </div>
        </div>

        <div className="selection-container">
          {getGeneralOptionsData?.data?.ekyc?.fund_source?.map(
            (item, index) => (
              <div
                className={`fund-source-button ${
                  ekycSourceOfFunds?.value === item?.value
                    ? "source-selected"
                    : ""
                }`}
                onClick={() => onSelectSource(item)}
                key={index}
              >
                {item?.label}
              </div>
            )
          )}
        </div>

        {ekycSourceOfFunds?.value === "other" && (
          <div className="other-source-textfield">
            <TextField
              multiline
              minRows={3}
              maxRows={6}
              fullWidth
              variant="outlined"
              value={ekycSourceOfFundsDetails || ""}
              onChange={onChangeOtherDetails}
              placeholder={t(
                "verification.ekyc.details_verification.please_specify"
              )}
            />
          </div>
        )}

        <div className="save-button-container">
          <div
            className={`save-button ${isFormValid() ? "" : "disabled-button"}`}
            onClick={onCloseDialog}
          >
            {t("common.save")}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SourceOfFundsDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
